module.exports = __webpack_public_path__ + "static/img/subbanner5.e09c7ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/banners/subbanner5.jpg
// module id = gWPJ
// module chunks = 1